import React, { useMemo, useRef, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { AgGridReact } from 'ag-grid-react';
import { localeTw } from 'main_consts';
import { ColDef, GridOptions } from 'ag-grid-community';
import { VcEGrid } from 'components/Grid';
import { inputChange } from 'main_func';
import { Imaster, IresultDetail } from '../type';
import Input from '../Input';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .ag-root-wrapper': {
      backgroundColor: 'transparent !important', // 覆寫背景色為透明
    },
    '& .ag-row': {
      backgroundColor: 'transparent !important', // 覆寫背景色為透明
    },
  },
}));

interface IProp {
  index: number;
  ehuPo: Imaster;
  userName: string;
}

const Invoiceform = (props: IProp): JSX.Element => {
  const { index, ehuPo: result, userName } = props;
  const classes = useStyles();
  const gridRef = useRef<any>(undefined);
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = [
      {
        // headerCheckboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        // checkboxSelection: true,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        minWidth: 70,
        width: 8,
        maxWidth: 70,
        filter: false,
        sortable: true,
        editable: false,

        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '貨物名稱',
        field: 'goodsSpec',
        minWidth: 200,
        cellStyle: {
          'white-space': 'normal', // 設定白色空間為正常，允許換行
        },
        autoHeight: true, // 自動調整行高
      },
      {
        headerName: '單價',
        field: 'unitPrice',
        minWidth: 80,
        width: 12,
        maxWidth: 120,
      },
      {
        headerName: '數量',
        field: 'qty',
        width: 8,
        minWidth: 80,
        maxWidth: 120,
      },
      {
        headerName: '數量單位',
        field: 'qtyUnit',
        width: 8,
        minWidth: 80,
        maxWidth: 120,
      },
      {
        headerName: '重量',
        field: 'nwt',
        width: 8,
        minWidth: 80,
        maxWidth: 120,
      },
      {
        headerName: '重量單位',
        field: 'nwtUnit',
        width: 8,
        minWidth: 80,
        maxWidth: 120,
      },
      {
        headerName: '幣別',
        field: 'currency',
        width: 8,
        minWidth: 80,
        maxWidth: 120,
      },
      {
        headerName: '總額',
        field: 'totalAmount',
        width: 8,
        minWidth: 80,
        maxWidth: 120,
      },
    ];

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 20,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };

  // const watermarkStyle: React.CSSProperties = {
  //   position: 'absolute',
  //   top: 0,
  //   left: 0,
  //   width: '100%',
  //   height: '100%',
  //   overflow: 'hidden',
  //   zIndex: -1,

  // };

  // const textStyle: React.CSSProperties = {
  //   position: 'absolute',
  //   top: '50%',
  //   left: '50%',
  //   transform: 'translate(-50%, -50%) rotate(-45deg)',
  //   whiteSpace: 'nowrap',
  //   fontSize: '5rem',
  //   color: 'rgba(0, 0, 0, 0.1)',
  //   pointerEvents: 'none',
  // };

  // const repeatText = new Array(100).fill(userName).join(' ');

  return (
    <React.Fragment key={index}>
      <form className="form-area" style={{ position: 'relative' }}>
        <div className="input-area">
          <div>
            <Grid container>
              <VcEGrid item className="input-text">
                銷售人姓名：
              </VcEGrid>
              <Grid item>
                <Input
                  maxLength={2}
                  value={result?.seContact}
                  name="seContact"
                />
              </Grid>
              <VcEGrid item className="input-text">
                銷售人電話：
              </VcEGrid>
              <Grid item>
                <Input
                  maxLength={2}
                  value={result?.seContactTel}
                  name="seContactTel"
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                銷售人地址：
              </VcEGrid>
              <Grid item xs={12} sm={8}>
                <Input
                  maxLength={200}
                  value={result?.seAddress}
                  name="seAddress"
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item className="input-text">
                收貨人姓名：
              </VcEGrid>
              <Grid item>
                <Input
                  maxLength={2}
                  value={result?.cnContact}
                  name="cnContact"
                />
              </Grid>
              <VcEGrid item className="input-text">
                收貨人電話：
              </VcEGrid>
              <Grid item>
                <Input
                  maxLength={2}
                  value={result?.cnContactTel}
                  name="cnContactTel"
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                收貨人地址：
              </VcEGrid>
              <Grid item xs={12} sm={8}>
                <Input
                  maxLength={200}
                  value={result?.cnAddress}
                  name="cnAddress"
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item className="input-text">
                訂購人姓名：
              </VcEGrid>
              <Grid item>
                <Input
                  maxLength={2}
                  value={result?.byContact}
                  name="byContact"
                />
              </Grid>
              <VcEGrid item className="input-text">
                訂購人電話：
              </VcEGrid>
              <Grid item>
                <Input
                  maxLength={2}
                  value={result?.byContactTel}
                  name="byContactTel"
                />
              </Grid>
            </Grid>
          </div>

          <div>
            <Grid container>
              <VcEGrid item className="input-text">
                寄件人姓名：
              </VcEGrid>
              <Grid item>
                <Input
                  maxLength={2}
                  value={result?.spContact}
                  name="spContact"
                />
              </Grid>
              <VcEGrid item className="input-text">
                寄件人電話：
              </VcEGrid>
              <Grid item>
                <Input
                  maxLength={2}
                  value={result?.spContactTel}
                  name="spContactTel"
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                寄件人地址：
              </VcEGrid>
              <Grid item xs={12} sm={8}>
                <Input
                  maxLength={200}
                  value={result?.spAddress}
                  name="spAddress"
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item className="input-text">
                總金額：
              </VcEGrid>
              <Grid item>
                <Input maxLength={14} value={result?.amount} name="amount" />
              </Grid>
            </Grid>
          </div>
        </div>
      </form>

      {result.ehuPoItemDTOs && result.ehuPoItemDTOs.length > 0 && (
        <form className="form-area">
          <div
            className={`ag-theme-alpine ${classes.root}`}
            style={{ height: '500px', backgroundColor: 'transparent' }}
          >
            <AgGridReact
              ref={gridRef}
              rowData={result.ehuPoItemDTOs}
              gridOptions={gridOptions}
              onGridReady={onGridReady}
            />
          </div>
        </form>
      )}
    </React.Fragment>
  );
};

export default Invoiceform;
